// Primary colors
export const baseWhite = "#FFFFFF";
export const baseBlack = "#000000";
export const sky25 = "#EBF5FF";
export const sky50 = "#DAEDFF";
export const sky100 = "#BCDBFF";
export const sky200 = "#94C3FF";
export const sky300 = "#699EFF";
export const sky400 = "#4778FF";
export const sky500 = "#264EFF";
export const sky600 = "#183BE5";
export const sky700 = "#1937BA";
export const sky800 = "#1D3592";
export const sky900 = "#111D55";
export const royalBlue25 = "#F5F7FF";
export const royalBlue50 = "#ECF0FF";
export const royalBlue100 = "#DDE3FF";
export const royalBlue200 = "#C2CBFF";
export const royalBlue300 = "#9CA7FF";
export const royalBlue400 = "#7579FF";
export const royalBlue500 = "#5B53FF";
export const royalBlue600 = "#4E36F5";
export const royalBlue700 = "#432AD8";
export const royalBlue800 = "#3625AE";
export const royalBlue900 = "#302689";
export const inkLight25 = "#FCFCFD";
export const inkLight50 = "#F9FAFB";
export const inkLight100 = "#F3F4F6";
export const inkLight200 = "#E5E7EB";
export const inkLight300 = "#D2D6DB";
export const inkLight400 = "#9DA4AE";
export const inkLight500 = "#6C737F";
export const inkLight600 = "#4D5761";
export const inkLight700 = "#384250";
export const inkLight800 = "#1F2A37";
export const inkLight900 = "#111927";
export const darkBlue25 = "#F5F5FA";
export const darkBlue50 = "#E9E9F5";
export const darkBlue100 = "#CFD0E8";
export const darkBlue200 = "#A5A9D4";
export const darkBlue300 = "#747BBC";
export const darkBlue400 = "#404489";
export const darkBlue500 = "#35386F";
export const darkBlue600 = "#2F315D";
export const darkBlue700 = "#2B2C4F";
export const darkBlue800 = "#2B2C4F";
export const darkBlue900 = "#0D0D18";

// Secondary colors
export const blue25 = "#F5FAFF";
export const blue50 = "#EFF8FF";
export const blue100 = "#D1E9FF";
export const blue200 = "#B2DDFF";
export const blue300 = "#84CAFF";
export const blue400 = "#53B1FD";
export const blue500 = "#2E90FA";
export const blue600 = "#1570EF";
export const blue700 = "#175CD3";
export const blue800 = "#1849A9";
export const blue900 = "#194185";
export const ink25 = "#E6E8EC";
export const ink50 = "#CFD4DA";
export const ink100 = "#B8C0C8";
export const ink200 = "#A2ABB6";
export const ink300 = "#8C97A4";
export const ink400 = "#768391";
export const ink500 = "#606E7E";
export const ink600 = "#4A5A6C";
export const ink700 = "#354659";
export const ink800 = "#1F3145";
export const ink900 = "#0A1D32";
export const success25 = "#F6FEF9";
export const success50 = "#EDFCF2";
export const success100 = "#D3F8DF";
export const success200 = "#AAF0C4";
export const success300 = "#73E2A3";
export const success400 = "#3CCB7F";
export const success500 = "#16B364";
export const success600 = "#099250";
export const success700 = "#087443";
export const success800 = "#095C37";
export const success900 = "#084C2E";
export const amber25 = "#FFFCF5";
export const amber50 = "#FFFAEB";
export const amber100 = "#FEF0C7";
export const amber200 = "#FEDF89";
export const amber300 = "#FEC84B";
export const amber400 = "#FDB022";
export const amber500 = "#F79009";
export const amber600 = "#DC6803";
export const amber700 = "#B54708";
export const amber800 = "#93370D";
export const amber900 = "#7A2E0E";
export const orangeDark25 = "#FFF9F5";
export const orangeDark50 = "#FFF4ED";
export const orangeDark100 = "#FFE6D5";
export const orangeDark200 = "#FFD6AE";
export const orangeDark300 = "#FF9C66";
export const orangeDark400 = "#FF692E";
export const orangeDark500 = "#FF4405";
export const orangeDark600 = "#E62E05";
export const orangeDark700 = "#BC1B06";
export const orangeDark800 = "#97180C";
export const orangeDark900 = "#771A0D";
export const error25 = "#FFFBFA";
export const error50 = "#FEF3F2";
export const error100 = "#FEE4E2";
export const error200 = "#FECDCA";
export const error300 = "#FDA29B";
export const error400 = "#F97066";
export const error500 = "#F04438";
export const error600 = "#D92D20";
export const error700 = "#B42318";
export const error800 = "#912018";
export const error900 = "#7A271A";
export const lightBlue600 = "#BDE9F3";
export const sorbetYellow600 = "#F7F49D";
export const parkGreen600 = "#A6EF9E";
export const curtainDarkInkLight40 = "#38425066";
export const curtainLightWhite40 = "#FFFFFF66";
//# sourceMappingURL=colors.js.map